<template>
    <div class="card mb-xl-3 mb-0">
        <div class="card-body p-1">

            <a href="#" class="card-header-action btn btn-lg btn-block btn-info p-xl-2 p-1" @click.prevent="addFavorite()" v-if="!saved">
                <i class="fas fa-star"></i>
                {{__("favorites.save")}}
            </a>
            <span class="card-header-action btn btn-lg btn-block btn-success p-xl-2 p-1" v-if="saved">
                <i class="fas fa-star"></i>
                {{__("favorites.saved")}}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['matchrequest_id'],
        data() {
            return {
                saved: false
            }
        },
        mounted() {
             Echo.channel('matchrequests.' + this.matchrequest_id)
            .listen('.readystate.changed', (e) => {
                this.saved = false;
            })
        },
        methods: {
            addFavorite() {
                axios.post('/api/matchrequests/add_favorite', {'id':this.matchrequest_id}).then(() =>{
                    this.saved = true;
                })
            }
        }
    }
</script>
